import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    
    
    {
        count: 1,
        title: 'Buildings',
        flaticon: 'flaticon-city',
        description: 'We create high scale structures, using quality materials and expert craftsmanship to bring our clients visions to life. We deliver exceptional results on time and on budget.',
    },
    {
        count: 5,
        title: 'Infrastructure',
        flaticon: 'flaticon-chart',
        description: 'We build the backbone of society with highways, bridges, interchanges, railways and ports connecting communities and enabling growth.',
    },
    {
        count: 4,
        title: 'Housing',
        flaticon: 'flaticon-decorating',
        description: 'Our team builds affordable and energy-efficient homes that contribute to the well-being of the community. Our expert builders and designers work closely with you to create homes that are not only functional but also aesthetically pleasing.',
    },
    {
        count: 3,
        title: 'Construction Units',
        flaticon: 'flaticon-crane',
        description: 'Our customized solutions for complex manufacturing needs of cement, petrochemical, chemicals and fertilizers deliver precision with optimal efficiency.',
    },
    // {
    //     count: 8,
    //     title: 'Electricity',
    //     flaticon: 'flaticon-drill',
    //     description: 'lorem Ipsum available, but the majority have suffered alterati on in some form, by ious by accident.',
    // },
    // {
    //     count: 2,
    //     title: 'Renovation',
    //     flaticon: 'flaticon-paint',
    //     description: 'lorem Ipsum available, but the majority have suffered alterati on in some form, by ious by accident.',
    // },
    // {
    //     count: 9,
    //     title: 'Refurbishment',
    //     flaticon: 'flaticon-art-and-design',
    //     description: 'lorem Ipsum available, but the majority have suffered alterati on in some form, by ious by accident.',
    // },
    
    {
        count: 6,
        title: 'Dams & Canals',
        flaticon: 'flaticon-sketch',
        description: 'We harness the power of water for reliable and sustainable energy solutions. Our innovative hydropower facilities help clients achieve energy independence.',
    },
    {
        count: 7,
        title: 'Mass Transit Systems',
        flaticon: 'flaticon-builder',
        description: 'End-to-end Building Management System including building maintenance & services for a hassle free experience.',
    },
    
]

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                                        <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <span className="icon-cell text-secondry"><i className={item.flaticon} /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                                            <p>{item.description}</p>
                                            {/* <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                            ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;